/* eslint-disable import/prefer-default-export */

const DEFAULT_RANGE_TOTAL = { start: undefined, end: undefined, total: 0 };

export {
  DEFAULT_RANGE_TOTAL,
};
